import React from 'react'
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button } from "reactstrap"

const Settings = () => {
  const addNewProductHandler = () => {
    
  }
  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs title="Dashboard" breadcrumbItem="Products" />
        <Button
          onClick={addNewProductHandler}
          className="bg-gradiant-blue text-capitalize"
        >
          add new product
        </Button>
      </div>
    </div>
  )
}

export default Settings